
import AddZoneModal from '../Modal/AddZoneModal';
import { permissionObj } from '../../../../Helpers/permission';
import DeleteModal from '../../../Modals/DeleteModal';
import '../../../../scss/colors.scss';
import { status } from '../../../../enums/statusEnum';
import NotInformation from '../../../../components/NotInformation';
import HeadTittle from '../../../../components/HeadTittle';
import routes from '../../../../Routes/routes';
import DivContainerBody from '../../../../components/DivContainerBody';
import {EditIcon, MapIcon} from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import {SingleZoneDetailsApp} from "../Funtionality/SingleZoneDetailsApp";
import SubZonesDetailsTable from "./SubZonesDetailsTable";
import TotalAccessService from "../TotalAccessService";
import CustomChip from "../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import React from "react";
import {Box} from "@mui/material";
import AuthorizedEmployeesTable from "./AuthorizedEmployeesTable";
import {EMPTY_VALUES} from "../../../../Apis/functions";

/**
 * SingleZoneDetails Component
 *
 * This component renders the detailed view for a single zone. It displays the zone's name, status, common area details,
 * sub-zone details, and authorized employees. Additionally, it provides action buttons for updating the zone and
 * displaying its devices. The component also handles various modals including adding zones/buildings, removing plans,
 * managing authorized employees, and deletion confirmation for both employees and sub-zones.
 *
 * @component
 * @returns {JSX.Element} A JSX element representing the detailed view of a zone.
 *
 * @example
 * // To render the SingleZoneDetails component:
 * <SingleZoneDetails />
 *
 * @Email: azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 */

const SingleZoneDetails = () => {

    const {
        t,
        setBackResponse,
        DEV,
        permission,
        zoneDetailFatherAndChild,
        setModalShow,
        setIsFatherZone,
        selectSubZoneForDelete,
        setDeleteShowSubZone,
        stack,
        modalShow,
        isFatherZone,
        deleteShowSubZone,
        deleteSubZone,
        setSelectSubZoneForDelete,
        setIsAllCheckedSubZone,
        isAllCheckedSubZone,
        modified,
        setModified,
        renderZoneStack
    } = SingleZoneDetailsApp();

    return (
        <>
            <HeadTittle
                name="details"
                link={stack.length === 1 ? routes.zone.list : routes.hash}
                onBack={stack.length !== 1 ? () => setBackResponse(true) : undefined}
                divStack={renderZoneStack()}
            >
                {(DEV || permission?.includes(permissionObj?.WEB_ZONE_UPDATE)) && (
                    <ButtonAction
                        id="btn_szd_update"
                        name="update"
                        className="btn-icon-add"
                        Icon={EditIcon}
                        url={`${routes.zone.update}${zoneDetailFatherAndChild?.id}`}
                    />
                )}
                {(DEV || permission?.includes(permissionObj?.WEB_ZONE_READ_DEVICES)) && (
                    <ButtonAction
                        id="btn_szd_show_devices"
                        name="show_devices"
                        className="btn-icon-add"
                        Icon={MapIcon}
                        url={`${routes.zone.devices}${zoneDetailFatherAndChild?.id}`}
                        splitName={false}
                    />
                )}
            </HeadTittle>

            <DivContainerBody>
                <div className='row'>
                    <div className='col-lg-6'>
                        <div className='d-flex justify-content-center my-4'>
                                <h3>{t('details')}</h3>
                        </div>
                        <div className={'d-flex justify-content-center align-items-center align-content-center'}>
                           <div className={'d-flex flex-column  justify-content-center align-items-center align-content-center'}>
                               <p className={"ibl-font-w-600"}>{t('name')}</p>
                               <p className={"font-color-general-950"}>{zoneDetailFatherAndChild?.name}</p>
                               <p className={"ibl-font-w-600"}>{t('status')}</p>
                               <Box className={'d-flex justify-content-center align-items-center align-content-center'}>
                                   <CustomChip
                                       fontColor={statusFontColor[zoneDetailFatherAndChild?.status?.id]}
                                       borderColor={statusBorderColor[zoneDetailFatherAndChild?.status?.id]}
                                       background={(zoneDetailFatherAndChild?.status?.id ? statusColor[zoneDetailFatherAndChild.status.id] : '')}
                                       legend={t(status[zoneDetailFatherAndChild?.status?.id]).toUpperCase() || EMPTY_VALUES.DEFAULT}
                                   />
                               </Box>
                           </div>
                        </div>
                    </div>
                    <div className='container-line col-lg-6'>
                        <div className='d-flex justify-content-center my-4'>
                            <h3>{t('common_area')}</h3>
                        </div>
                        {zoneDetailFatherAndChild?.commonArea != null ?
                            <div className={'d-flex justify-content-center align-items-center align-content-center'}>
                                <div className={'d-flex flex-column  justify-content-center align-items-center align-content-center'}>
                                    <p className={'font-color-general-950 ibl-font-w-600'}>{t('schedule_use')}</p>
                                    <p className={"ibl-span"}>{t('from')}</p>
                                    <p>{zoneDetailFatherAndChild?.commonArea?.fromTime}</p>
                                    <p className={"ibl-span"}>{t('to')}</p>
                                    <p>{zoneDetailFatherAndChild?.commonArea?.toTime}</p>
                                    <p className={"font-color-general-950"}>{zoneDetailFatherAndChild?.name}</p>
                                </div>
                            </div>:
                            <NotInformation text={t('no_information')} card={false} />
                        }

                    </div>
                </div>
                <div>
                    <SubZonesDetailsTable
                        zoneDetailFatherAndChild={zoneDetailFatherAndChild}
                        setSelectSubZoneForDelete={setSelectSubZoneForDelete}
                        setModalShow={setModalShow}
                        setIsFatherZone={setIsFatherZone}
                        selectSubZoneForDelete={selectSubZoneForDelete}
                        setDeleteShowSubZone={setDeleteShowSubZone}
                        isAllCheckedSubZone={isAllCheckedSubZone}
                        setIsAllCheckedSubZone={setIsAllCheckedSubZone}
                        tableId={"tb_rer_subzone_table"}
                        searchId={"txt_rer_search_subzone"}
                        modified={modified}
                        setModified={setModified}
                    />
                    {(DEV || permission?.includes(permissionObj?.WEB_ZONE_READ_DEVICES)) && (
                        <TotalAccessService
                            item={zoneDetailFatherAndChild}
                            modified={modified}
                            setModified={setModified}
                        />
                    )}

                    <AuthorizedEmployeesTable/>
                </div>
            </DivContainerBody>

            { modalShow &&
                <AddZoneModal
                    title={t('create')}
                    check='true'
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    isFatherZone={isFatherZone}
                    modified={modified}
                    setModified={setModified}
                />
            }

            { deleteShowSubZone &&
                <DeleteModal
                    show={deleteShowSubZone}
                    onHide={() => setDeleteShowSubZone(false)}
                    onClickFn={() => deleteSubZone(selectSubZoneForDelete)}
                    data={selectSubZoneForDelete}
                    title_modal={'delete_first_access_zone'}
                    element_modal={'sub_zone'}
                    isReset={setSelectSubZoneForDelete}
                    isAllReset={setIsAllCheckedSubZone}
                />
            }

        </>
    );
};

export default SingleZoneDetails;
